import React, { useCallback, useEffect } from "react";
import { ReactComponent as ExclamationWarningIcon } from "../../../Assets/ActionIcons/ExclamationWarningIcon.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { PaymentRoutes } from "../../../Contracts/Routes";
import { useClientPortalMetadataStore } from "../../../Store/ClientPortalMetadata";

const SessionEndedPage: React.FC = () => {
  const { logout } = useAuth0();
  const { clientPortalUUID } = useClientPortalMetadataStore();
  const searchParams = new URLSearchParams(window.location.search);
  const fromClientPortal = searchParams.get("fromClientPortal") === "true";

  const logoutAndRedirect = useCallback(async () => {
    if (fromClientPortal) {
      if (!clientPortalUUID) {
        window.location.href = PaymentRoutes.INTERNAL_SERVER_ERROR;
        return;
      }
      const target = PaymentRoutes.CLIENT_PORTAL_LOGIN.replace(
        ":id",
        clientPortalUUID
      );
      window.location.href = target;
      return;
    }

    await logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }, [logout, fromClientPortal, clientPortalUUID]);

  useEffect(() => {
    const timeout = setTimeout(logoutAndRedirect, 5000);

    return () => clearTimeout(timeout);
  }, [logoutAndRedirect]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800 p-6">
      <ExclamationWarningIcon className="w-12 h-12 text-yellow-500 mb-4" />

      <h1 className="text-3xl font-semibold mb-2">Session Ended</h1>
      <p className="text-center max-w-md text-gray-600 mb-6">
        Your session has ended due to inactivity, a password change, an expired token, or a logout.
        We’re redirecting you to the login page to start fresh.
      </p>

      <div className="text-sm text-gray-500 animate-pulse">Redirecting in a few seconds...</div>

      <button
        onClick={logoutAndRedirect}
        className="mt-6 px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
      >
        Go to Login Now
      </button>
    </div>
  );
};

export default SessionEndedPage;
